import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { useToast } from '@/hooks/use-toast';

export interface SupportFormData {
  email?: string;
  name?: string;
  subjectType: string;
  subject: string;
  message: string;
}

export const useSupport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const { toast } = useToast();

  const sendSupportEmail = async (formData: SupportFormData) => {
    // Pour les utilisateurs non connectés, vérifier que l'email est fourni
    if (!user && !formData.email) {
      toast({
        title: 'Erreur',
        description: 'Veuillez fournir votre adresse email',
        variant: 'destructive',
      });
      return false;
    }

    setIsLoading(true);
    
    try {
      const userEmail = formData.email || user?.email || '';
      const userName = formData.name || 
        (user?.user_metadata?.first_name ? 
          `${user.user_metadata.first_name} ${user.user_metadata.last_name || ''}`.trim() : 
          userEmail);

      const { error } = await supabase.functions.invoke('send-support-email', {
        body: {
          subjectType: formData.subjectType,
          subject: formData.subject,
          message: formData.message,
          userEmail,
          userName,
          isAuthenticated: !!user
        }
      });

      if (error) {
        throw error;
      }

      toast({
        title: 'Message envoyé',
        description: 'Votre demande a été envoyée. Nous vous répondrons par email.',
      });
      
      return true;
    } catch (error) {
      console.error('Erreur lors de l\'envoi du support:', error);
      toast({
        title: 'Erreur',
        description: 'Une erreur est survenue lors de l\'envoi. Veuillez réessayer.',
        variant: 'destructive',
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    sendSupportEmail,
    isLoading,
  };
};